import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import About from "./components/About";
import HowToUse from "./components/HowToUse";
import Background from "./components/Background";
import Counter from "./components/Counter";
import FAQ from "./components/FAQ";
import NewsletterDownload from "./components/NewsletterDownload";
import Privacy from "./components/Privacy";
import Founder from "./components/Founder";
import Japanese from "./components/Japanese"; // Japanese page

// Countdown component
function Countdown() {
  const launchDate = new Date("2025-09-13T10:30:00"); // Launch date
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const diff = launchDate - now;

      if (diff <= 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / (1000 * 60)) % 60),
          seconds: Math.floor((diff / 1000) % 60),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-indigo-50 dark:bg-gray-900 text-center">
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 dark:text-white mb-6">
        QuickCaptionIO iOS App Launching Soon!
      </h1>
      <p className="text-lg sm:text-xl text-slate-700 dark:text-slate-300 mb-10">
        Stay tuned! App will be available from September 26, 2025.
      </p>
      <div className="text-3xl font-bold text-indigo-500 dark:text-indigo-400 space-x-4">
        <span>{timeLeft.days}d</span>
        <span>{timeLeft.hours}h</span>
        <span>{timeLeft.minutes}m</span>
        <span>{timeLeft.seconds}s</span>
      </div>
    </div>
  );
}

// Main site wrapper
function MainSite({ darkMode, toggleDarkMode }) {
  return (
    <div className="relative scroll-smooth font-sans min-h-screen bg-gradient-to-br from-indigo-50 via-white to-pink-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition-colors duration-500">
      <Background />
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <Hero />
      <About />
      <HowToUse />
      <Counter />
      <FAQ />
      <NewsletterDownload />
      <Founder />
      <Footer />
    </div>
  );
}

export default function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [isLaunched, setIsLaunched] = useState(false);

  useEffect(() => {
    // Dark mode from localStorage
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      setDarkMode(true);
      document.documentElement.classList.add("dark");
    }

    // Launch check
    const now = new Date();
    const launchDate = new Date("2025-09-26T18:25:00");
    setIsLaunched(now >= launchDate);
  }, []);

  const toggleDarkMode = () => {
    if (darkMode) {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    }
    setDarkMode(!darkMode);
  };

  return (
    <Router>
      <Routes>
        {/* Root page */}
        <Route path="/" element={isLaunched ? <MainSite darkMode={darkMode} toggleDarkMode={toggleDarkMode} /> : <Countdown />} />

        {/* Japanese page */}
        <Route path="/japanese" element={isLaunched ? <Japanese /> : <Countdown />} />

        {/* Privacy page */}
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}
